import { render } from "./NotPublished.vue?vue&type=template&id=1bf4526a&scoped=true&ts=true"
import script from "./NotPublished.vue?vue&type=script&lang=ts"
export * from "./NotPublished.vue?vue&type=script&lang=ts"

import "./NotPublished.vue?vue&type=style&index=0&id=1bf4526a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf4526a"]])

export default __exports__